var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-defi-manage-collateral-confirmation"},[_c('defi-deposit-confirmation',{attrs:{"params":_vm.params,"token":_vm.params.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }